import { ActivatedRoute, Router,NavigationExtras } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-makupcategory',
  templateUrl: './makupcategory.component.html',
  styleUrls: ['./makupcategory.component.scss'],
})
export class MakupcategoryComponent implements OnInit {
  subcat:any;
  constructor(public router:Router, public route:ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(JSON.parse(params.sub_cat))
      this.subcat=JSON.parse(params.sub_cat);
      // if (params && params.special) {
      //   this.data = JSON.parse(params.special);
      // }
      
    });
  }
  select_location(catId){
    console.log(catId);
    //routerLink="/makuplist"
    let navigationExtras: NavigationExtras = {
      queryParams: {
        sub_cat: JSON.stringify(catId),
      }
      
    };
    this.router.navigate(['/location'], navigationExtras);
  }
  //(click)="select_location()"
}
